// extracted by mini-css-extract-plugin
export default {"TypographyWithToolTipProps__Tooltip":"TypographyWithTooltipProps_TypographyWithToolTipProps__Tooltip__SHoO3"};